import { UserStore } from '@/store/user';
import { User } from '@/types/user';

export const userProfileSelectors = {
  email: (s: UserStore): string => s.user?.email || '',
  nickName: (s: UserStore) => {
    return s.user?.name;
  },
  userAvatar: (s: UserStore): string => s.user?.avatar || '',
  userPicture: (s: UserStore): string => s.user?.picture || '',
  userId: (s: UserStore) => s.user?.user_id || s.user?.id,
  userProfile: (s: UserStore): User | null | undefined => s.user,
};

export const authSelectors = {
  isLoaded: (s: UserStore) => s.isLoaded,
  isLogin: (s: UserStore) => s.isSignedIn,
  screens: (s: UserStore) => s.screens || [],
  features: (s: UserStore) => s.features || [],
  screensLoaded: (s: UserStore) => s.screensLoaded || false,
  entitlementsStatus: (s: UserStore) => s.entitlementsStatus,
  entitlementsWorkspaceId: (s: UserStore) => s.entitlementsWorkspaceId || null,
};
